"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The KeyTakeAway model module.
 * @module model/KeyTakeAway
 * @version 1.1.3-alpha.1
 */
class KeyTakeAway {
  /**
   * Constructs a new <code>KeyTakeAway</code>.
   * @alias module:model/KeyTakeAway
   * @param media_id {String} 
   * @param ordinal {Number} 
   * @param caption {String} 
   * @param timeout {Number} 
   * @param id {String} 
   * @param created_at {String} 
   * @param updated_at {String} 
   */
  constructor(media_id, ordinal, caption, timeout, id, created_at, updated_at) {
    KeyTakeAway.initialize(this, media_id, ordinal, caption, timeout, id, created_at, updated_at);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, media_id, ordinal, caption, timeout, id, created_at, updated_at) {
    obj['media_id'] = media_id;
    obj['ordinal'] = ordinal;
    obj['caption'] = caption;
    obj['timeout'] = timeout;
    obj['id'] = id;
    obj['created_at'] = created_at;
    obj['updated_at'] = updated_at;
  }

  /**
   * Constructs a <code>KeyTakeAway</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/KeyTakeAway} obj Optional instance to populate.
   * @return {module:model/KeyTakeAway} The populated <code>KeyTakeAway</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new KeyTakeAway();
      if (data.hasOwnProperty('media_id')) {
        obj['media_id'] = _ApiClient.default.convertToType(data['media_id'], 'String');
      }
      if (data.hasOwnProperty('ordinal')) {
        obj['ordinal'] = _ApiClient.default.convertToType(data['ordinal'], 'Number');
      }
      if (data.hasOwnProperty('caption')) {
        obj['caption'] = _ApiClient.default.convertToType(data['caption'], 'String');
      }
      if (data.hasOwnProperty('timeout')) {
        obj['timeout'] = _ApiClient.default.convertToType(data['timeout'], 'Number');
      }
      if (data.hasOwnProperty('id')) {
        obj['id'] = _ApiClient.default.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('created_at')) {
        obj['created_at'] = _ApiClient.default.convertToType(data['created_at'], 'String');
      }
      if (data.hasOwnProperty('created_by')) {
        obj['created_by'] = _ApiClient.default.convertToType(data['created_by'], 'String');
      }
      if (data.hasOwnProperty('date_created')) {
        obj['date_created'] = _ApiClient.default.convertToType(data['date_created'], 'String');
      }
      if (data.hasOwnProperty('time_created')) {
        obj['time_created'] = _ApiClient.default.convertToType(data['time_created'], 'String');
      }
      if (data.hasOwnProperty('updated_at')) {
        obj['updated_at'] = _ApiClient.default.convertToType(data['updated_at'], 'String');
      }
      if (data.hasOwnProperty('updated_by')) {
        obj['updated_by'] = _ApiClient.default.convertToType(data['updated_by'], 'String');
      }
      if (data.hasOwnProperty('date_updated')) {
        obj['date_updated'] = _ApiClient.default.convertToType(data['date_updated'], 'String');
      }
      if (data.hasOwnProperty('time_updated')) {
        obj['time_updated'] = _ApiClient.default.convertToType(data['time_updated'], 'String');
      }
      if (data.hasOwnProperty('deleted_at')) {
        obj['deleted_at'] = _ApiClient.default.convertToType(data['deleted_at'], 'String');
      }
      if (data.hasOwnProperty('deleted_by')) {
        obj['deleted_by'] = _ApiClient.default.convertToType(data['deleted_by'], 'String');
      }
      if (data.hasOwnProperty('date_deleted')) {
        obj['date_deleted'] = _ApiClient.default.convertToType(data['date_deleted'], 'String');
      }
      if (data.hasOwnProperty('time_deleted')) {
        obj['time_deleted'] = _ApiClient.default.convertToType(data['time_deleted'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>KeyTakeAway</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>KeyTakeAway</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of KeyTakeAway.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['media_id'] && !(typeof data['media_id'] === 'string' || data['media_id'] instanceof String)) {
      throw new Error("Expected the field `media_id` to be a primitive type in the JSON string but got " + data['media_id']);
    }
    // ensure the json data is a string
    if (data['caption'] && !(typeof data['caption'] === 'string' || data['caption'] instanceof String)) {
      throw new Error("Expected the field `caption` to be a primitive type in the JSON string but got " + data['caption']);
    }
    // ensure the json data is a string
    if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
      throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
    }
    // ensure the json data is a string
    if (data['created_by'] && !(typeof data['created_by'] === 'string' || data['created_by'] instanceof String)) {
      throw new Error("Expected the field `created_by` to be a primitive type in the JSON string but got " + data['created_by']);
    }
    // ensure the json data is a string
    if (data['time_created'] && !(typeof data['time_created'] === 'string' || data['time_created'] instanceof String)) {
      throw new Error("Expected the field `time_created` to be a primitive type in the JSON string but got " + data['time_created']);
    }
    // ensure the json data is a string
    if (data['updated_by'] && !(typeof data['updated_by'] === 'string' || data['updated_by'] instanceof String)) {
      throw new Error("Expected the field `updated_by` to be a primitive type in the JSON string but got " + data['updated_by']);
    }
    // ensure the json data is a string
    if (data['time_updated'] && !(typeof data['time_updated'] === 'string' || data['time_updated'] instanceof String)) {
      throw new Error("Expected the field `time_updated` to be a primitive type in the JSON string but got " + data['time_updated']);
    }
    // ensure the json data is a string
    if (data['deleted_by'] && !(typeof data['deleted_by'] === 'string' || data['deleted_by'] instanceof String)) {
      throw new Error("Expected the field `deleted_by` to be a primitive type in the JSON string but got " + data['deleted_by']);
    }
    // ensure the json data is a string
    if (data['time_deleted'] && !(typeof data['time_deleted'] === 'string' || data['time_deleted'] instanceof String)) {
      throw new Error("Expected the field `time_deleted` to be a primitive type in the JSON string but got " + data['time_deleted']);
    }
    return true;
  }
}
KeyTakeAway.RequiredProperties = ["media_id", "ordinal", "caption", "timeout", "id", "created_at", "updated_at"];

/**
 * @member {String} media_id
 */
KeyTakeAway.prototype['media_id'] = undefined;

/**
 * @member {Number} ordinal
 */
KeyTakeAway.prototype['ordinal'] = undefined;

/**
 * @member {String} caption
 */
KeyTakeAway.prototype['caption'] = undefined;

/**
 * @member {Number} timeout
 */
KeyTakeAway.prototype['timeout'] = undefined;

/**
 * @member {String} id
 */
KeyTakeAway.prototype['id'] = undefined;

/**
 * @member {String} created_at
 */
KeyTakeAway.prototype['created_at'] = undefined;

/**
 * @member {String} created_by
 */
KeyTakeAway.prototype['created_by'] = undefined;

/**
 * @member {String} date_created
 */
KeyTakeAway.prototype['date_created'] = undefined;

/**
 * @member {String} time_created
 */
KeyTakeAway.prototype['time_created'] = undefined;

/**
 * @member {String} updated_at
 */
KeyTakeAway.prototype['updated_at'] = undefined;

/**
 * @member {String} updated_by
 */
KeyTakeAway.prototype['updated_by'] = undefined;

/**
 * @member {String} date_updated
 */
KeyTakeAway.prototype['date_updated'] = undefined;

/**
 * @member {String} time_updated
 */
KeyTakeAway.prototype['time_updated'] = undefined;

/**
 * @member {String} deleted_at
 */
KeyTakeAway.prototype['deleted_at'] = undefined;

/**
 * @member {String} deleted_by
 */
KeyTakeAway.prototype['deleted_by'] = undefined;

/**
 * @member {String} date_deleted
 */
KeyTakeAway.prototype['date_deleted'] = undefined;

/**
 * @member {String} time_deleted
 */
KeyTakeAway.prototype['time_deleted'] = undefined;
var _default = exports.default = KeyTakeAway;